export const DefaultErrorMessage = "Sự cố kỹ thuật, vui lòng thử lại sau";
export const UpdateDataSuccessfully = "Cập nhật dữ liệu thành công";
export const QuestionRemove = "Bạn có chắc chắn muốn xóa không?";